import { ReactComponent as IconSvg } from './icon_upload.svg';
import Icon, { IconProps } from './icon';

const IconUpload = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconUpload;
